import { useNavigate } from "react-router-dom";
import ModalLoading from "../../../components/Formularios/Modal/ModalLoading";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Card, Col, Form, Row } from "react-bootstrap";
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Switch, TextField, CircularProgress } from "@mui/material";
import { Button as ButtonCustom } from "../../../components/Formularios/Buttons/Button";
import { mdiCheckCircle, mdiKeyboardReturn, mdiPlus } from "@mdi/js";
import ModalUploadImage from "../../../components/Formularios/Modal/ModalUpload";
import ModalDetalheFilial from "./modalDetalheFilial";
import { ITabela } from "../../../components/Formularios/Table/TabelaInterface";
import Tabela from "../../../components/Formularios/Table";

import { dadosUF } from "../../../components/dadosFixos/UF";
import { dadosPais } from "../../../components/dadosFixos/Pais";

import { getSessionData } from "../../../utils/storageUtils";
import axios from "axios";

import { Controller, useForm } from "react-hook-form";
import { EmpresaInterface } from "../../../types/EmpresaInteface";
import { endpointPrincipal } from "../../../api/endPoints/endpointPrincipal/endpointPrincipal";
import { showConfirmationDialog } from "../../../components/Formularios/Modal/ModalExcluir";

interface FormEmpresaProps {
  idempresa?: string;
  acao?: string;
}

const FormEmpresa = ({ idempresa, acao }: FormEmpresaProps) => {
  const { register, handleSubmit, watch, setValue, reset, control, formState: { errors } } = useForm<EmpresaInterface>();

  const navigate = useNavigate();
  const tokenAuth = getSessionData("MultClinicaWebToken") || "";
  const isSuper = getSessionData("isPerfilSuper") || "";

  // Define se está no modo de visualização
  const isVisualizando = acao === 'Visualizar';

  // Função vazia para usar quando estiver no modo visualização
  const handleNoOp = (dados: any) => {
    // Não faz nada quando em modo visualização
    console.log('Operação não permitida em modo de visualização');
  };

  const [expandir, setExpandir] = useState<string | false>(false);

  const abrirOpcoes =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandir(isExpanded ? panel : false);
    };

  //#region Controla as guias
  const [guia, setGuia] = useState("1");

  const capturaGuia = (event: React.SyntheticEvent, novaGuia: string) => {
    setGuia(novaGuia);
  };
  //#endregion

  const [showUpload, setShowUpload] = useState<boolean>(false);

  const [ativo, setAtivo] = useState<boolean>(true);
  const [logradouro, setLogradouro] = useState<string>("");
  const [complemento, setComplemento] = useState<string>("");
  const [bairro, setBairro] = useState<string>("");
  const [cidade, setCidade] = useState<string>("");
  const [codIbge, setCodIbge] = useState<string>("");
  const [uf, setUF] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);

  // Novo estado para controlar o modal de filiais
  const [showModalFilial, setShowModalFilial] = useState<boolean>(false);
  const [filialSelecionada, setFilialSelecionada] = useState<any>(null);
  const [acaoFilial, setAcaoFilial] = useState<string>("Novo");
  const [filiais, setFiliais] = useState<any[]>([]);

  // Colunas para a tabela de filiais
  const colunasFiliais: ITabela[] = [
    { titulo: "Nome Fantasia", acesso: "fantasia" },
    { titulo: "Responsável", acesso: "responsavel" },
    { titulo: "Telefone", acesso: "fone" },
    { titulo: "Email", acesso: "email" },
    { titulo: "Cidade", acesso: "cidade" },
    { titulo: "UF", acesso: "uf" },
    { titulo: "Situação", acesso: "situacao" },
  ];

  /*
    * Carrega dados da empresa para edição
    */
  const carregarEmpresaPorId = async () => {
    setLoading(true);
    try {
      const { data } = await endpointPrincipal.get(`empresas/${idempresa}`);
      setValue("id_empresa", data.id_empresa);
      setValue("cnpj", data.cnpj);
      setValue("ie", data.ie);
      setValue("fantasia", data.fantasia);
      setValue("razao_social", data.razao_social);
      setValue("logradouro", data.logradouro);
      setValue("complemento", data.complemento);
      setValue("numero", data.numero);
      setValue("bairro", data.bairro);
      setValue("cidade", data.cidade);
      setValue("cmun", data.cmun);
      setValue("cep", data.cep);
      setValue("uf", data.uf);
      setValue("cuf", data.cuf);
      setValue("cpais", data.cpais);
      setValue("email", data.email);
      setValue("situacao", data.situacao);
      setValue("fone", data.fone);
      setValue("celular", data.celular);
      setValue("site", data.site);

    } catch (error) {
      toast.error("Falha ao carregar dados. Motivo: " + error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (idempresa !== "novo") {
      carregarEmpresaPorId();
    }
  }, []);

  /**
   * Atualiza os dados do banco de dados existente por id
   */
  const atualizarEmpresaPorId = async (data: EmpresaInterface) => {
    setLoading(true);
    try {
      await endpointPrincipal.put(`empresas/${idempresa}`, data);
      toast.success(`Empresa atualizada com sucesso`);
      setTimeout(() => navigate(-1), 2000);
    } catch (error) {
      toast.error("Falha ao atualizar empresa. Motivo: " + error);
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region Inclui os dados do banco de dados
  const incluirEmpresa = async (data: EmpresaInterface) => {
    setLoading(true);
    try {
      // Adicionando valores padrão para campos obrigatórios
      const dadosEmpresa = {
        ...data,
        situacao: 1, // 1 para ativo, 0 para inativo
        itempagina: 10, // valor padrão para itens por página
        num_filial: 1, // valor padrão para número da filial
        tempo_ocioso: 30 // valor padrão para tempo ocioso em minutos
      };
      
      await endpointPrincipal.post("empresas", dadosEmpresa);
      toast.success(`Empresa adicionada com sucesso`);
      setTimeout(() => navigate(-1), 2000);
    } catch (error) {
      toast.error(`Erro ao adicionar empresa`);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (data: EmpresaInterface) => {
    if (idempresa === "novo") {
      incluirEmpresa(data);
    } else {
      atualizarEmpresaPorId(data);
    }
  };

  const buscarCep = async (cep: string) => {
    // Remove caracteres não numéricos (como hífen)
    const cepLimpo = cep.replace(/\D/g, '');
    
    if (cepLimpo.length < 8) {
      toast.error("CEP inválido! O CEP deve conter 8 dígitos.");
      return;
    }
    
    setLoading(true);
    
    try {
      const { data } = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      
      if (data.erro) {
        toast.error("CEP inválido ou não localizado!");
        return;
      }
      
      // Atualiza os estados locais
      setLogradouro(data.logradouro || "");
      setComplemento(data.complemento || "");
      setBairro(data.bairro || "");
      setCidade(data.localidade || "");
      setUF(data.uf || "");
      setCodIbge(data.ibge || "");
      
      // Atualiza os campos do formulário
      setValue("logradouro", data.logradouro || "");
      setValue("complemento", data.complemento || "");
      setValue("bairro", data.bairro || "");
      setValue("cidade", data.localidade || "");
      setValue("uf", data.uf || "");
      
      // Se o componente usar cmun para código do município IBGE
      if (data.ibge) {
        setValue("cmun", data.ibge);
      }
      
      // Formata o CEP com hífen para exibição, se necessário
      const cepFormatado = cepLimpo.replace(/^(\d{5})(\d{3})$/, "$1-$2");
      setValue("cep", cepFormatado);
      
      toast.success("CEP localizado com sucesso!");
    } catch (erro: any) {
      console.error("Erro ao buscar CEP:", erro);
      const msg =
        erro.response?.data.message === undefined
          ? erro.message
          : erro.response.data.message;
      toast.error(`Erro ao buscar CEP. Motivo: ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Definindo valores padrão ao iniciar o formulário
    if (idempresa === "novo") {
      setValue("situacao", 1);
      setValue("itempagina", 10);
      setValue("num_filial", 1);
      setValue("tempo_ocioso", 30);
    }
  }, []);

  useEffect(() => {
    setValue("situacao", ativo ? 1 : 0);
  }, [ativo]);

  // Função para formatar o CEP enquanto o usuário digita
  const formatarCep = (value: string) => {
    // Remove todos os caracteres não numéricos
    const cepLimpo = value.replace(/\D/g, '');
    
    // Limita a 8 dígitos
    const cepLimitado = cepLimpo.slice(0, 8);
    
    // Formata como 00000-000 se tiver pelo menos 6 dígitos
    if (cepLimitado.length > 5) {
      return `${cepLimitado.slice(0, 5)}-${cepLimitado.slice(5)}`;
    }
    
    return cepLimitado;
  };

  // Carregar filiais da empresa
  const carregarFiliais = async () => {
    if (idempresa && idempresa !== "novo") {
      try {
        const { data } = await endpointPrincipal.get(`empresas-filiais/empresa/${idempresa}`);
        setFiliais(Array.isArray(data) ? data : []);
      } catch (error) {
        toast.error("Falha ao carregar filiais. Motivo: " + error);
      }
    }
  };

  useEffect(() => {
    carregarFiliais();
  }, [idempresa]);

  // Funções para manipular filiais
  const handleOpenModalFilial = () => {
    setFilialSelecionada(null);
    setAcaoFilial("Novo");
    setShowModalFilial(true);
  };

  const handleCloseModalFilial = () => {
    setShowModalFilial(false);
    setFilialSelecionada(null);
  };

  const visualizarFilial = (dados: any) => {
    setFilialSelecionada(dados);
    setAcaoFilial("Visualizar");
    setShowModalFilial(true);
  };

  const editarFilial = (dados: any) => {
    setFilialSelecionada(dados);
    setAcaoFilial("EditarItem");
    setShowModalFilial(true);
  };

  const excluirFilial = async (dados: any) => {
    await showConfirmationDialog(
      "Excluir Filial",
      `Tem certeza que deseja excluir a filial ${dados.fantasia}?`,
      "question",
      "Excluir",
      "Cancelar"
    ).then(async (resultado) => {
      if (resultado.confirmed) {
        try {
          await endpointPrincipal.delete(`empresas-filiais/${dados.id_filial}`);
          toast.success("Filial excluída com sucesso!");
          carregarFiliais();
        } catch (error) {
          toast.error("Falha ao excluir filial. Motivo: " + error);
        }
      }
    });
  };

  const handleSubmitFilial = async (dados: any) => {
    try {
      const dadosComIdEmpresa = {
        ...dados,
        id_empresa: Number(idempresa)
      };

      if (acaoFilial === "Novo") {
        await endpointPrincipal.post("empresas-filiais", dadosComIdEmpresa);
        toast.success("Filial adicionada com sucesso!");
      } else if (acaoFilial === "EditarItem") {
        await endpointPrincipal.put(`empresas-filiais/${filialSelecionada.id_filial}`, dadosComIdEmpresa);
        toast.success("Filial atualizada com sucesso!");
      }
      carregarFiliais();
      handleCloseModalFilial();
    } catch (error) {
      toast.error("Falha ao salvar filial. Motivo: " + error);
    }
  };

  return (
    <>
      <Card>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Card.Body>
            <Box sx={{ width: "100%" }}>
              <Row>
                <Col xs={12} sm={6} md={6} lg={3}>
                  <TextField
                    sx={{
                      width: "100%",
                      mb: 3,
                      "& .MuiInputBase-input.Mui-disabled": {
                        backgroundColor: "rgba(242, 242, 242, 0.50)"
                      }
                    }}
                    id="outlined-basic"
                    label="Código Empresa"
                    size="small"
                    {...register("id_empresa")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      readOnly: true,
                    }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    disabled
                  />
                </Col>
                <Col xs={12} sm={6} md={6} lg={3}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="CNPJ"
                    size="small"
                    {...register("cnpj", { required: true })}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={6} lg={3}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Inscrição Estadual"
                    size="small"
                    {...register("ie")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={6} lg={3}>
                  <label htmlFor="" className="form-label me-2">
                    Ativo
                  </label>
                  <Switch
                    checked={ativo}
                    onChange={() => setAtivo(!ativo)}
                    disabled={isVisualizando}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Razão Social"
                    size="small"
                    {...register("razao_social")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Nome Fantasia"
                    size="small"
                    {...register("fantasia")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6} md={6}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Telefone"
                    size="small"
                    {...register("fone")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Celular"
                    size="small"
                    {...register("celular")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Email"
                    size="small"
                    {...register("email")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Site"
                    size="small"
                    {...register("site")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6} md={2}>
                  <Controller
                    name="cep"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        sx={{ width: "100%", mb: 3 }}
                        id="outlined-basic"
                        label="CEP"
                        size="small"
                        value={field.value || ""}
                        onChange={(e) => {
                          const formattedValue = formatarCep(e.target.value);
                          field.onChange(formattedValue);
                        }}
                        onBlur={(e) => {
                          field.onBlur();
                          if (!isVisualizando) buscarCep(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={loading || isVisualizando}
                        InputProps={{
                          endAdornment: loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null,
                        }}
                      />
                    )}
                  />
                </Col>
                <Col xs={12} sm={6} md={4}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Logradouro"
                    size="small"
                    {...register("logradouro")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={4}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Complemento"
                    size="small"
                    {...register("complemento")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={2}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Número"
                    size="small"
                    {...register("numero")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6} md={6}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Bairro"
                    size="small"
                    {...register("bairro")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={6}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Cidade"
                    size="small"
                    {...register("cidade")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={2}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                    <Controller
                      name="uf"
                      control={control}
                      render={({ field }) => (
                        <Select
                          sx={{ width: "100%", mb: 3 }}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Estado"
                          size="small"
                          onChange={(event: SelectChangeEvent) => {
                            field.onChange(event.target.value);
                          }}
                          value={field.value ?? ''}
                          disabled={isVisualizando}
                        >
                          {dadosUF.map((item) => (
                            <MenuItem key={item.uf} value={item.uf}>
                              {item.nome}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Col>
                <Col xs={12} sm={6} md={2}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Cod. IBGE"
                    size="small"
                    {...register("cmun")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
                <Col xs={12} sm={6} md={2}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">País</InputLabel>
                    <Controller
                      name="cpais"
                      control={control}
                      render={({ field }) => (
                        <Select
                          sx={{ width: "100%", mb: 3 }}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="País"
                          size="small"
                          onChange={(event: SelectChangeEvent) => {
                            field.onChange(event.target.value);
                          }}
                          value={field.value ?? '1058'}
                          disabled={isVisualizando}
                        >
                          {dadosPais.map((item) => (
                            <MenuItem key={item.codpais} value={item.codpais}>
                              {item.pais}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Col>
              </Row>
              <hr />
              <p className="text-muted">
                A filial é opcional. A empresa pode ser salva sem esse vínculo, e a filial pode ser cadastrada depois.
              </p>
              {idempresa !== "novo" && (
                <>
                  <Row>
                    <Col sm={2}>
                      <ButtonCustom
                        type="button"
                        className="btn btn-primary rounded-2 d-flex align-items-center gap-1"
                        descricaoBotao="Incluir Filial"
                        icone={mdiPlus}
                        onclick={handleOpenModalFilial}
                        disabled={isVisualizando}
                      />
                    </Col>
                  </Row>
                  <hr />
                  {filiais.length === 0 ? (
                    <p className="text-muted mb-0">
                      Nenhuma filial vinculada. O cadastro da empresa permanece válido.
                    </p>
                  ) : (
                    <Row>
                      <Tabela
                        coluna={colunasFiliais}
                        itemsPerPage={5}
                        dados={filiais}
                        onVisuClick={visualizarFilial}
                        onEditClick={isVisualizando ? handleNoOp : editarFilial}
                        onDeleteClick={isVisualizando ? handleNoOp : excluirFilial}
                        onImprimirClick={() => {}}
                        usaImprimir={false}
                      />
                    </Row>
                  )}
                </>
              )}
            </Box>
          </Card.Body>
          <Card.Footer>
            <div className="d-flex my-2 gap-1 justify-content-between">
              <ButtonCustom
                type="button"
                className="btn btn-outline-secondary rounded-2 d-flex align-items-center gap-1"
                descricaoBotao="Voltar"
                icone={mdiKeyboardReturn}
                onclick={() => {
                  navigate(-1);
                }}
              />
              <ButtonCustom
                type="submit"
                className="btn btn-success rounded-2 d-flex align-items-center gap-1"
                descricaoBotao="Salvar"
                icone={mdiCheckCircle}
                disabled={isVisualizando}
              />
            </div>
          </Card.Footer>
        </Form>
      </Card>
      <ModalUploadImage
        show={showUpload}
        label="Realizando Upload da Imagem ..."
      />
      <ModalLoading show={loading} label="Carregado dados da empresa ..." />
      <ModalDetalheFilial
        showModal={showModalFilial}
        acao={acaoFilial}
        onClose={handleCloseModalFilial}
        onSubmit={handleSubmitFilial}
        dadosFilial={filialSelecionada}
      />
    </>
  );
};
export default FormEmpresa;
